module.exports = __webpack_public_path__ + "media/images/header__bg-81de4d7afcbf01a55a9d9f8232fc37d2.jpg";